export enum SinglePlanProtectionDetailsVariants {
  Control = 'control',
  Test = 'test',
}
